export const TOAST_SUCCESS_MESSAGE = 'TOAST_SUCCESS_MESSAGE';

export const PROJECTS = [{
  id: 'CW',
  name: "Client Web"
}, {
  id: 'SER',
  name: "Server"
}];
